module.exports = __webpack_public_path__ + "img/H3.14315d8b.png";